export default (siteName) => [
    {
        path: 'variable-statement',
        name: 'variable-statement',
        component: () => import('../../components/dashboard/Finance/VariableStatement/indexPage.vue'),
        meta: {
            title: `財務收支管理${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'variable-statement/add/',
        name: 'variable-statement-add',
        component: () => import('../../components/dashboard/Finance/VariableStatement/EditPage.vue'),
        meta: {
            title: `新增財務收支${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'variable-statement/bank-transfer/',
        name: 'variable-statement-bank-transfer',
        component: () => import('../../components/dashboard/Finance/VariableStatement/BankTransferPage.vue'),
        meta: {
            title: `財務收支-帳戶互轉${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'variable-statement/bank-transfer/add/',
        name: 'variable-statement-bank-transfer-add',
        component: () => import('../../components/dashboard/Finance/VariableStatement/BankTransferAddPage.vue'),
        meta: {
            title: `財務收支-帳戶互轉${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'variable-statement/bank-transfer/:sno/edit/',
        name: 'variable-statement-bank-transfer-edit',
        component: () => import('../../components/dashboard/Finance/VariableStatement/BankTransferAddPage.vue'),
        meta: {
            title: `財務收支-帳戶互轉${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'variable-statement/:sno/edit/',
        name: 'variable-statement-edit',
        component: () => import('../../components/dashboard/Finance/VariableStatement/EditPage.vue'),
        meta: {
            title: `編輯財務收支${siteName}`,
            activeMenu: 'finance',
        },
    },
];
